// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o6-9";
export var arrowButtonContainer = "_o6-5";
export var arrowButtonIcon = "_o6-6";
export var carouselArrowButton = "_o6-2";
export var carouselElementContainer = "_o6-1";
export var currentSlide = "_o6-8";
export var left = "_o6-3";
export var otherSlide = "_o6-a";
export var productCarouselContainer = "_o6-0";
export var right = "_o6-4";
export var sliderOverflow = "_o6-7";